<div
  cdkDrag
  class="dci-drag draggable-modal"
  (cdkDragStarted)="dragStart()"
  (cdkDragEnded)="dragEnd()"
  cdkDragBoundary=".exotics-main"
  [ngStyle]="{ 'top.px': windowTop, 'left.px': windowLeft }"
>
  <div class="dci-container-content draggable-modal_container-content">
    <div
      class="draggable-modal_container-content__menu-bar"
      cdkDragHandle
      (mousedown)="updateZIndex()"
    >
      <div class="draggable-modal__menu-bar__title">DCI Grid</div>
      <button class="button-close" (click)="close()"></button>
    </div>

    <div class="dci-container-content__main">
      <div
        [formGroup]="controlPanelForm"
        class="dci-container-content__main__control-panel"
      >
        <div
          class="dci-container-content__main__control-panel__currency-amount-container"
        >
          <div
            class="dci-container-content__main__control-panel__currency-amount-container__group"
          >
            <label class="group-label">Deposit Taker </label>
            <app-selector
              class="group-dropdown"
              formControlName="depositTaker"
              [passedItems]="entities"
              (valueEmitter)="changeInDepositCurrency($event.value, true)"
            ></app-selector>
          </div>
          <div
            class="dci-container-content__main__control-panel__currency-amount-container__group"
          >
            <label class="group-label">Currency</label>
            <app-selector
              class="group-dropdown"
              formControlName="currency"
              [passedItems]="currencies"
              (valueEmitter)="saveSpecificChange('currency', $event.value)"
            ></app-selector>
          </div>
          <div
            class="dci-container-content__main__control-panel__currency-amount-container__group"
          >
            <label class="group-label">Amount</label>
            <clr-input-container>
              <input
                clrInput
                type="text"
                id="amount"
                formControlName="amount"
                class="group-textbox"
                [inputValidator]="['numericShorthand']"
                (click)="textBoxRestrictionHandler($event, ' ', 'click')"
                (keydown)="textBoxRestrictionHandler($event, ' ', 'keydown')"
                (blur)="saveSpecificChange('amount', $any($event.target).value)"
              />
            </clr-input-container>
          </div>
        </div>

        <div
          class="dci-container-content__main__control-panel__start-date-container"
        >
          <div
            class="dci-container-content__main__control-panel__start-date-container__group"
          >
            <label class="group-label">Value Date</label>
            <div
              class="dci-container-content__main__control-panel__start-date-container__group__item"
            >
              <date-with-spinner-info
                formControlName="startDate"
                [id]="'startDate'"
                [info]="startDateInfo.info"
                [inputValidatorKey]="['dateShorthand']"
                [readOnly]="true"
              ></date-with-spinner-info>
            </div>
          </div>
        </div>

        <div
          class="dci-container-content__main__control-panel__interest-strike-container"
        >
          <div
            class="dci-container-content__main__control-panel__interest-strike-container__group"
          >
            <label class="group-label">Interest</label>
            <app-selector
              class="group-dropdown"
              formControlName="interest"
              [passedItems]="dciData.interest"
              (valueEmitter)="saveSpecificChange('interest', $event.value)"
            ></app-selector>
          </div>

          <div
            class="dci-container-content__main__control-panel__interest-strike-container__group"
          >
            <label class="group-label">Solve for</label>

            <app-selector
              class="group-dropdown"
              formControlName="solveFor"
              [passedItems]="dciData.solveFor"
              (valueEmitter)="saveSpecificChange('solveFor', $event.value)"
            ></app-selector>
          </div>
        </div>
      </div>

      <div class="dci-container-content__main__body">
        <div class="tabs-vertical dci-container-content__main__body__tabs">
          <ul class="nav scrollable-content" role="tablist">
            <li role="presentation" class="nav-item" *ngFor="let tab of tabs">
              <button
                class="btn btn-link nav-link active"
                [ngClass]="{ active: tab.selected }"
                [attr.aria-selected]="tab.selected"
                type="button"
                (click)="tabSelected(tab)"
              >
                {{ tab.currency }}
              </button>
            </li>
          </ul>
          <section
            role="tabpanel"
            *ngFor="let tab of tabs; index as i"
            [hidden]="!tab.selected"
            [ngClass]="{ 'visible-section': tab.selected }"
            #sections
          >
            <app-dci-tab
              *ngIf="tab.selected"
              [tabData]="tab"
              [controlPanelForm]="controlPanelForm"
              (loadStrategy)="loadStrategy.emit($event)"
            ></app-dci-tab>
          </section>
          <div class="no-tab-available" *ngIf="tabs.length === 0">
            <div class="no-tab-available__text">No Tab Selected</div>
          </div>
        </div>
      </div>

      <div
        class="dci-container-content__main__footer-hide-container"
        [ngClass]="{
          'dci-container-content__main__footer-hide-container--hide':
            !showFooter
        }"
      >
        <button class="hide-button" (click)="showFooter = !showFooter">
          <cds-icon
            class="hide-button__icon"
            shape="angle-double"
            [ngClass]="{ 'hide-button__icon--rotated': !showFooter }"
          ></cds-icon>
        </button>
      </div>

      <div class="dci-container-content__main__footer" *ngIf="showFooter">
        <div
          class="dci-container-content__main__footer__field-container"
          [formGroup]="controlPanelForm"
        >
          <div class="dci-container-content__main__footer__field">
            <label class="field-label">Sales Margin (running yield %)</label>
            <clr-input-container>
              <input
                clrInput
                type="text"
                id="marginBps"
                formControlName="marginBps"
                [inputValidator]="['percentage']"
                class="field-textbox"
                (click)="textBoxRestrictionHandler($event, '%', 'click')"
                (keydown)="textBoxRestrictionHandler($event, '%', 'keydown')"
                (blur)="
                  saveSpecificChange('marginBps', $any($event.target).value)
                "
              />
            </clr-input-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
